import { styled, Divider } from '@bluedolphin/ui';

export const CustomDivider = styled(Divider)(({ theme }) => ({
    margin: '12px 0px',
    alignSelf: 'stretch',
    border: '1px solid',
    borderColor: theme.palette.divider,
}));
